import { giftCategoryIdAtom } from '@activities/gift/GiftsActivity/fragments/GiftCategoryFragment/atoms/giftItemAtoms';
import BlankGift from '@components/blank/BlankGift';
import { useAtomValue } from 'jotai';

import GiftItem from '../GiftItem';
import PrepaidCardItem from '../PrepaidCardItem';
import useGiftItems from './hooks/useGiftItems';
import styles from './styles.module.scss';

function Contents() {
  const giftCategoryId = useAtomValue(giftCategoryIdAtom);
  const { items } = useGiftItems(giftCategoryId);
  if (items?.length === 0) {
    return (
          <BlankGift type='APPLY' />
    );
  }
  return (
        <div className={styles.contents} >
            {items?.map((item) => {
              if (item.giftItemType === 'PRODUCT') {
                return <GiftItem giftItem={item} key={item.id} />;
              }
              return <PrepaidCardItem giftItem={item}
                                      key={item.id} />;
            })}
            {/* <VisibleAction onVisible={fetchNext} /> */}
        </div>
  );
}
export default Contents;
